import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=d70109ac&scoped=true&"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
import style0 from "./SysGatewayRouteList.vue?vue&type=style&index=0&id=d70109ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70109ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70109ac')) {
      api.createRecord('d70109ac', component.options)
    } else {
      api.reload('d70109ac', component.options)
    }
    module.hot.accept("./SysGatewayRouteList.vue?vue&type=template&id=d70109ac&scoped=true&", function () {
      api.rerender('d70109ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysGatewayRouteList.vue"
export default component.exports